export function clientShortName(){
    const fullUrl = window.location.host
    const parts = fullUrl.split('.')
    let clientShortName = parts[0]

    // NS-9956 / 10830 Preprod handling, PW
    if(clientShortName) {
        if(clientShortName.includes('prod')) {
            clientShortName = clientShortName.replace('prod', 'test')
        }
    }

    return clientShortName
}
